import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Circle as VisCircle } from '@vis.gl/react-google-maps';
import { useReportBounds } from "../lib/BoundsRegistry";
export const Circle = ({ lat, lng, radius, editable, draggable, strokeColor, strokeOpacity, strokeWeight, fillColor, fillOpacity, onRadiusChanged, onCenterChanged, onClick }) => {
    useReportBounds(useMemo(() => [{ lat, lng }], [lat, lng]));
    return (_jsx(VisCircle, { center: { lat, lng }, radius: radius ?? 100, editable: editable ?? true, draggable: draggable ?? true, strokeColor: strokeColor ?? '#000000', strokeOpacity: strokeOpacity ?? 0.8, strokeWeight: strokeWeight ?? 4, fillColor: fillColor ?? '#000000', fillOpacity: fillOpacity ?? 0.3, onClick: () => onClick?.(), onRadiusChanged: radius => onRadiusChanged?.(radius), onCenterChanged: center => {
            if (center && onCenterChanged) {
                onCenterChanged({ lat: center.lat(), lng: center.lng() });
            }
        } }));
};
